import type { Assessor } from "../api/dto";

const normalizeEmail = (email: string | null | undefined): string | null => {
  const normalized = email?.trim().toLowerCase();
  return normalized ? normalized : null;
};

/**
 * Returns the assessor assigned to an inspection/exam when it is certain that the logged-in user is *not* that
 * assessor, so the UI can warn before someone fills in the wrong inspection/exam by accident.
 *
 * An assessor record isn't linked to a user account; the only link is the assessor's (optional) email address
 * compared to the email in the user's token. When that can't be decided — no assessor assigned, the assessor has
 * no email, or the user has no email — this returns `null` (no warning), to avoid false alarms.
 *
 * The tablet app (`compentcy_test`) implements the same rule; keep both in sync.
 */
export const findOtherAssessor = (
  assessorId: string | null | undefined,
  assessors: Assessor[],
  userEmail: string | null | undefined,
): Assessor | null => {
  if (!assessorId) return null;
  const assessor = assessors.find((a) => a.id === assessorId);
  const assessorEmail = normalizeEmail(assessor?.email);
  const ownEmail = normalizeEmail(userEmail);
  if (!assessor || !ownEmail) return null;
  return assessorEmail === ownEmail ? null : assessor;
};
